/* wellio-pdp-native.js v3 - PDP native Wellio - Claude 24/09/2026
   1. Gallery (vuot / thumb / dots)
   2. Buy box kieu IM8 (v3): the goi -> input id + selling_plan, an/hien so luong, khong dung widget Appstle
   5. Carousel (nut <- ->), video review, tab Proven, CTA cuon len buy box, sticky bar
   Gia KHONG gan cung: Liquid tinh san vao data-* cua tung the goi. */
(function () {
  'use strict';
  var root = document.querySelector('[data-wl-native]');
  if (!root) return;

  function $(s, el) { return (el || document).querySelector(s); }
  function $$(s, el) { return Array.prototype.slice.call((el || document).querySelectorAll(s)); }
  function setText(el, t) { if (el && el.textContent !== t) el.textContent = t; }

  /* ---------- 1. gallery ---------- */
  var gal = $('[data-wl-gallery]', root);
  if (gal) {
    var track = $('[data-track]', gal);
    var thumbs = $$('[data-thumbs] button', gal);
    var dots = $$('[data-dots] span', gal);
    var mark = function (i) {
      thumbs.forEach(function (b, k) { b.classList.toggle('is-active', k === i); });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
    };
    var gt;
    track.addEventListener('scroll', function () {
      clearTimeout(gt);
      gt = setTimeout(function () { mark(Math.round(track.scrollLeft / Math.max(1, track.clientWidth))); }, 60);
    }, { passive: true });
    thumbs.forEach(function (b) {
      b.addEventListener('click', function () {
        var i = Number(b.getAttribute('data-i'));
        track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
        mark(i);
      });
    });
  }

  /* ---------- 2. buy box kieu IM8: chon goi ----------
     Moi the .wl-plan mang san data-variant / data-plan (selling plan id, rong = mua 1 lan) / data-qty / data-sum.
     Bam the = chi doi class + gia tri input an -> khong ve lai DOM, khong doi widget app -> muot.
     Form gui: id=<variant> & selling_plan=<plan> (bo trong -> input bi disabled -> mua 1 lan). */
  var buy = $('#wl-buy', root);
  var form = $('form[data-type="add-to-cart-form"]', root);
  var idInput = form && form.querySelector('input[name="id"]');
  var spInput = form && form.querySelector('[data-wl-sp]');
  var qtyBox = $('[data-wl-qty]', root);
  var qtyInput = qtyBox && qtyBox.querySelector('input[name="quantity"]');
  var plans = $$('.wl-plan', root);
  var sum = $('[data-wl-sticky-sum]', root);

  function choose(card, first) {
    if (!card || !idInput) return;
    var inp = card.querySelector('input');
    if (inp && inp.disabled) return;
    plans.forEach(function (p) {
      var on = p === card;
      p.classList.toggle('is-active', on);
      var r = p.querySelector('input'); if (r) r.checked = on;
    });
    var vid = card.getAttribute('data-variant');
    var sp = card.getAttribute('data-plan') || '';
    var changed = idInput.value !== vid;
    idInput.value = vid;
    if (spInput) { spInput.value = sp; spInput.disabled = !sp; }
    var showQty = card.getAttribute('data-qty') === '1';
    if (qtyBox) {
      qtyBox.hidden = !showQty;
      if (!showQty && qtyInput) qtyInput.value = 1;
    }
    if (sum) setText(sum, card.getAttribute('data-sum') || '');
    // "One Time Purchase" bam theo pack dang chon: chon 90-Day -> once = 3 chai gia le (lam gia sub nhin re hon)
    var ov = card.getAttribute('data-once-variant');
    var once = $('.wl-plan--once', root);
    if (ov && once && once !== card) {
      var op = card.getAttribute('data-once-price') || '';
      once.setAttribute('data-variant', ov);
      once.setAttribute('data-qty', card.getAttribute('data-once-qty') || '1');
      var lbl = (once.querySelector('.wl-plan__name') || {}).textContent || 'One Time Purchase';
      once.setAttribute('data-sum', lbl.trim() + ' · ' + op);
      $$('[data-wl-once-price]', once).forEach(function (el) { setText(el, op); });
    }
    if (!first) {
      try {
        var u = new URL(location.href);
        u.searchParams.set('variant', vid);
        if (sp) u.searchParams.set('selling_plan', sp); else u.searchParams.delete('selling_plan');
        history.replaceState(history.state, '', u.toString());
      } catch (e) {}
      if (changed) idInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
  plans.forEach(function (p) {
    p.addEventListener('click', function (e) { e.preventDefault(); choose(p); });
    var r = p.querySelector('input');
    if (r) r.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); choose(p); }
    });
  });
  // khoi tao: the dang active (mac dinh tu metafield), neu URL co ?selling_plan= khop the nao thi uu tien the do
  (function () {
    var start = $('.wl-plan.is-active', root) || plans[0];
    try {
      var q = new URL(location.href).searchParams;
      var qsp = q.get('selling_plan');
      var hit = qsp && plans.filter(function (p) { return p.getAttribute('data-plan') === qsp; })[0];
      if (hit) start = hit;
    } catch (e) {}
    choose(start, true);
  })();

  /* chan widget Appstle neu app embed van chen vao buy box (CSS da an, day la xoa han de khong tranh input selling_plan) */
  function killAppstle() { $$('.appstle_sub_widget', buy || root).forEach(function (w) { w.remove(); }); }
  killAppstle();
  try {
    var mo = new MutationObserver(function (list) {
      for (var i = 0; i < list.length; i++) if (list[i].addedNodes.length) { killAppstle(); break; }
    });
    if (form) mo.observe(form.parentElement || form, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 8000);
  } catch (e) {}

  /* ---------- 5a. carousel arrows ---------- */
  $$('[data-scroll]', root).forEach(function (btn) {
    btn.addEventListener('click', function () {
      var sc = btn.parentElement.querySelector('[data-scroller]');
      if (!sc) return;
      var card = sc.firstElementChild;
      var step = card ? card.getBoundingClientRect().width + 8 : sc.clientWidth;
      sc.scrollBy({ left: step * Number(btn.getAttribute('data-scroll')), behavior: 'smooth' });
    });
  });

  /* ---------- 5b. video review: bam play -> phat, dung video khac ---------- */
  $$('[data-video]', root).forEach(function (m) {
    var v = m.querySelector('video');
    var btn = m.querySelector('.wl-play');
    if (!v) return;
    v.removeAttribute('controls');
    if (btn) btn.addEventListener('click', function () { v.play(); });
    v.addEventListener('play', function () {
      v.setAttribute('controls', '');
      m.classList.add('is-playing');
      $$('[data-video] video', root).forEach(function (o) { if (o !== v) o.pause(); });
    });
    v.addEventListener('pause', function () { m.classList.remove('is-playing'); });
  });

  /* ---------- 5c. tab Proven ---------- */
  $$('.wl-proven', root).forEach(function (sec) {
    var tabs = $$('.wl-tab', sec), panels = $$('.wl-tabpanel', sec);
    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        var i = t.getAttribute('data-tab');
        tabs.forEach(function (x) { var on = x === t; x.classList.toggle('is-active', on); x.setAttribute('aria-selected', on); });
        panels.forEach(function (p) { p.hidden = p.getAttribute('data-panel') !== i; });
      });
    });
  });

  /* ---------- 5d. CTA -> cuon len buy box ---------- */
  $$('[data-wl-top]', root).forEach(function (a) {
    a.addEventListener('click', function (e) {
      if (!buy) return;
      e.preventDefault();
      buy.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  /* ---------- 5e. sticky bar: hien khi nut ATC da cuon qua (nam tren man hinh) ---------- */
  var sticky = $('[data-wl-sticky]', root);
  var atc = $('[data-wl-atc]', root);
  if (sticky && atc) {
    var ticking = false;
    var upd = function () { ticking = false; sticky.hidden = atc.getBoundingClientRect().bottom > 0; };
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(upd); } }, { passive: true });
    upd();
    var sAdd = $('[data-wl-sticky-add]', sticky);
    if (sAdd) sAdd.addEventListener('click', function () { atc.click(); });
  }

  /* ---------- 5f. dong icon: <br> an tren mobile -> chen dau cach de chu khong dinh nhau ---------- */
  $$('.wl-perk p br', root).forEach(function (br) { br.insertAdjacentText('beforebegin', ' '); });
})();
